<script setup lang="ts">
defineOptions({ inheritAttrs: false });

defineProps<{
  color?: 'radiant';
}>();
</script>

<template>
  <div
    class="relative"
    :class="$attrs.class"
  >
    <div
      v-if="color === 'radiant'"
      class="absolute inset-0 bg-gradient-to-br from-primary-50 to-primary-100 -z-10"
    />
    <slot />
  </div>
</template>
